import { render } from "./LiveClipper.vue?vue&type=template&id=060e92e0&scoped=true"
import script from "./LiveClipper.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveClipper.vue?vue&type=script&setup=true&lang=js"

import "./LiveClipper.vue?vue&type=style&index=0&id=060e92e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060e92e0"],['__file',"src/components/LiveClipping/LiveClipper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "060e92e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('060e92e0', __exports__)) {
    api.reload('060e92e0', __exports__)
  }
  
  module.hot.accept("./LiveClipper.vue?vue&type=template&id=060e92e0&scoped=true", () => {
    api.rerender('060e92e0', render)
  })

}


export default __exports__